<template>
  <v-container
    id="clientes-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <div v-if="!paginaEnable">
      <h1 style="display: none">
        Usuário não tem permissão a essa página não existente
      </h1>
    </div>
    <div v-else>
      <v-row>
        <v-col
          cols="12"
          class="container"
        >
          <v-row id="analiseFaturamentoFltrosId">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <dashboard-filtros
                :primeiro="enablePrimeiroDia"
                :ultimo="enableUltimoDia"
                :empresas="enableEmpresa"
                :url="link"
                :vendedores="enableVendedores"
                :areas="enableAreas"
                :redes="enableRedes"
                :supervisores="enableSupervisores"
                :classificacoes="enableClassificacao"
                :cidades="enableCidades"
                :linha-producao="enableLinhasProducao"
                :corrigir-css="css"
              />
            </v-col>
          </v-row>
          <v-divider class="mb-5" />
          <v-row>
            <v-col
              id="componenteAnaliseProduto"
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Produtos não Comercializados
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row id="tableFatClassificacaoMes">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <template>
                        <div>
                          <div
                            v-if="loading"
                            :style="styleObject"
                            class="text-center"
                          >
                            <v-icon
                              light
                              class="custom-loader"
                              :style="styleObject"
                            >
                              mdi-cached
                            </v-icon>
                            Carregando dados...
                          </div>
                          <div
                            v-else-if="error"
                            class="alert alert-danger"
                          >
                            {{ error }}
                          </div>
                          <div
                            v-else
                          >
                            <template>
                              <v-row v-if="enableBtn">
                                <v-col
                                  id="btnPdf"
                                  cols="12"
                                  sm="1"
                                  md="1"
                                  lg="1"
                                >
                                  <v-btn
                                    small
                                    :color="corPrimaria"
                                    dark
                                    :loading="imprimindo"
                                    @click="imprimirPdf()"
                                  >
                                    <v-icon>
                                      mdi-printer
                                    </v-icon>
                                    Exporta pdf
                                    <template v-slot:loader>
                                      <span>Exportando pdf...</span>
                                    </template>
                                  </v-btn>
                                </v-col>
                                <v-col
                                  id="btnExcel"
                                  cols="12"
                                  sm="1"
                                  md="1"
                                  lg="1"
                                >
                                  <v-btn
                                    small
                                    :color="corPrimaria"
                                    dark
                                    :loading="imprimindoExcel"
                                    @click="exportExcel()"
                                  >
                                    <v-icon>
                                      mdi-printer
                                    </v-icon>
                                    Exporta excel
                                    <template v-slot:loader>
                                      <span>Exportando excel...</span>
                                    </template>
                                  </v-btn>
                                </v-col>
                              </v-row>
                              <div
                                id="idTable"
                                style="overflow-x: auto;"
                              >
                                <v-row>
                                  <v-col
                                    cols="12"
                                    sm="3"
                                    md="3"
                                    lg="3"
                                  >
                                    <v-select
                                      v-if="enableEstoque"
                                      v-model="selectEstoque"
                                      :items="filtroEstoque"
                                      item-value="id"
                                      item-text="nomeExibicao"
                                      label="Filtro Estoque"
                                      return-object
                                      @change="filtrarEstoque()"
                                    />
                                  </v-col>
                                </v-row>
                                <table
                                  style="width: 100%; color: black; border-collapse: collapse;"
                                  class="elevation-1"
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                      />
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        @click="mudarOrdenacao('classificacao')"
                                      >
                                        Classificação
                                        <v-icon small>
                                          {{ ordenarDados === 'classificacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                        </v-icon>
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        @click="mudarOrdenacao('faturamentoOrdenacao')"
                                      >
                                        Faturamento
                                        <v-icon small>
                                          {{ ordenarDados === 'faturamentoOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                        </v-icon>
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        @click="mudarOrdenacao('volumeOrdenacao')"
                                      >
                                        Volume (L)
                                        <v-icon small>
                                          {{ ordenarDados === 'volumeOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                        </v-icon>
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        @click="mudarOrdenacao('precoMedioOrdenacao')"
                                      >
                                        Preço Médio (R$/L)
                                        <v-icon small>
                                          {{ ordenarDados === 'precoMedioOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                        </v-icon>
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        @click="mudarOrdenacao('estoqueOrdenacao')"
                                      >
                                        Estoque
                                        <v-icon small>
                                          {{ ordenarDados === 'estoqueOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                        </v-icon>
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        @click="mudarOrdenacao('custoTotalOrdenacao')"
                                      >
                                        Custo total
                                        <v-icon small>
                                          {{ ordenarDados === 'custoTotalOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                        </v-icon>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody
                                    v-for="(item, index) in (dadosClassificacaoFiltro.length > 0 ? dadosClassificacaoFiltro : dadosClassificacao)"
                                    :key="item.classificacao"
                                  >
                                    <!-- Linha principal -->
                                    <tr>
                                      <td style="text-align: center;">
                                        <button @click="toggleExpand(index)">
                                          {{ expanded.includes(index) ? '▲' : '▼' }}
                                        </button>
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: left;"
                                      >
                                        {{ item.classificacao }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.faturamento }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.volume }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.precoMedio }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.estoque }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.custoTotal }}
                                      </td>
                                    </tr>
                                    <!-- Linha expandida -->
                                    <tr
                                      v-if="expanded.includes(index)"
                                      :key="'expanded-' + item.id"
                                    >
                                      <td colspan="8">
                                        <table
                                          style="width: 100%; border-collapse: collapse; margin-top: 10px;"
                                        >
                                          <thead>
                                            <tr>
                                              <th
                                                id="dadoMovimentacaoHeader"
                                                style="text-align: center;"
                                                @click="mudarOrdenacaoProduto('produto', index)"
                                              >
                                                Produto
                                                <v-icon small>
                                                  {{ ordenarDadosProdutos === 'produto' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                                </v-icon>
                                              </th>
                                              <th
                                                id="dadoMovimentacaoHeader"
                                                style="text-align: center;"
                                                @click="mudarOrdenacaoProduto('faturamentoOrdenacao', index)"
                                              >
                                                Faturamento
                                                <v-icon small>
                                                  {{ ordenarDadosProdutos === 'faturamentoOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                                </v-icon>
                                              </th>
                                              <th
                                                id="dadoMovimentacaoHeader"
                                                style="text-align: center;"
                                                @click="mudarOrdenacaoProduto('dataFaturaOrdenacao', index)"
                                              >
                                                Última Venda
                                                <v-icon small>
                                                  {{ ordenarDadosProdutos === 'dataFaturaOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                                </v-icon>
                                              </th>
                                              <th
                                                id="dadoMovimentacaoHeader"
                                                style="text-align: center;"
                                                @click="mudarOrdenacaoProduto('diasSemFaturamento', index)"
                                              >
                                                Dias Não Movimentados
                                                <v-icon small>
                                                  {{ ordenarDadosProdutos === 'diasSemFaturamento' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                                </v-icon>
                                              </th>
                                              <th
                                                id="dadoMovimentacaoHeader"
                                                style="text-align: center;"
                                                @click="mudarOrdenacaoProduto('volumeOrdenacao', index)"
                                              >
                                                Volume (L)
                                                <v-icon small>
                                                  {{ ordenarDadosProdutos === 'volumeOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                                </v-icon>
                                              </th>
                                              <th
                                                id="dadoMovimentacaoHeader"
                                                style="text-align: center;"
                                                @click="mudarOrdenacaoProduto('precoMedioOrdenacao', index)"
                                              >
                                                Preço Médio (R$/L)
                                                <v-icon small>
                                                  {{ ordenarDadosProdutos === 'precoMedioOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                                </v-icon>
                                              </th>
                                              <th
                                                id="dadoMovimentacaoHeader"
                                                style="text-align: center;"
                                                @click="mudarOrdenacaoProduto('estoqueOrdenacao', index)"
                                              >
                                                Estoque
                                                <v-icon small>
                                                  {{ ordenarDadosProdutos === 'estoqueOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                                </v-icon>
                                              </th>
                                              <th
                                                id="dadoMovimentacaoHeader"
                                                style="text-align: center;"
                                                @click="mudarOrdenacaoProduto('custoTotalOrdenacao', index)"
                                              >
                                                Custo Total
                                                <v-icon small>
                                                  {{ ordenarDadosProdutos === 'custoTotalOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                                </v-icon>
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr
                                              v-for="(sub, idx) in item.dadosProdutos"
                                              :key="idx"
                                            >
                                              <td
                                                id="dadoMovimentacao"
                                                style="text-align: left;"
                                              >
                                                {{ sub.produto }}
                                              </td>
                                              <td
                                                id="dadoMovimentacao"
                                                style="text-align: right;"
                                              >
                                                {{ sub.faturamento }}
                                              </td>
                                              <td
                                                id="dadoMovimentacao"
                                                style="text-align: right;"
                                              >
                                                {{ sub.dataFatura }}
                                              </td>
                                              <td
                                                id="dadoMovimentacao"
                                                style="text-align: right;"
                                              >
                                                {{ sub.diasSemFaturamento }}
                                              </td>
                                              <td
                                                id="dadoMovimentacao"
                                                style="text-align: right;"
                                              >
                                                {{ sub.volume }}
                                              </td>
                                              <td
                                                id="dadoMovimentacao"
                                                style="text-align: right;"
                                              >
                                                {{ sub.precoMedio }}
                                              </td>
                                              <td
                                                id="dadoMovimentacao"
                                                style="text-align: right;"
                                              >
                                                {{ sub.estoque }}
                                              </td>
                                              <td
                                                id="dadoMovimentacao"
                                                style="text-align: right;"
                                              >
                                                {{ sub.custoTotal }}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </template>
                          </div>
                        </div>
                      </template>
                    </v-col>
                  </v-row>
                </v-card-actions><br><br>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row><br>

      <dashboard-core-snackbar
        v-model="snackbar.visible"
        :visible="snackbar.visible"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :message="snackbar.message"
      />
    </div>
  </v-container>
</template>

<script>
  import eventEmit from '../../../components/core/EventoEmit'
  import Produto from '../../../../../services/analiseproduto5'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'
  import ExcelJS from 'exceljs'
  import { saveAs } from 'file-saver'

  export default {
    name: 'DashboardDetalheAnaliseProdutos5NaoComercializados',
    emits: [],
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
      DashboardFiltros: () => import('../../../components/core/FiltroDatas'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      paginaEnable: false,
      link: window.location.href,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresa: [],
      vendedor: [],
      supervisor: [],
      area: [],
      redes: [],
      classificacao: [],
      linhasProducao: [],
      cidades: [],
      permissaoAnaliseProduto: false,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableVendedores: true,
      enableSupervisores: true,
      enableRedes: true,
      enableAreas: true,
      enableClassificacao: true,
      enableLinhasProducao: true,
      enableCidades: true,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      dynamicPaddingAnaliseProduto1: '',
      enableLegenda: false,
      dadosClassificacao: [],
      dadosClassificacaoFiltro: [],
      expanded: [],
      loading: false,
      error: null,
      ordenarDados: '',
      ordenacaoDadosDecrescente: false,
      ordenarDadosProdutos: '',
      ordenacaoDadosProdutosDecrescente: false,
      css: 'height: 360px',
      filtroEstoque: [
        { id: 1, nomeExibicao: 'Todos' },
        { id: 2, nomeExibicao: 'Somente com estoque' },
      ],
      selectEstoque: [],
      enableEstoque: false,
      enableBtn: false,
      imprimindo: false,
      imprimindoExcel: false,
      headers: [
        { text: 'Classificação', value: 'classificacao', width: '20%', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', width: '16%', class: 'black--text title' },
        { text: 'Volume (l)', value: 'volume', align: 'right', width: '16%', class: 'black--text title' },
        { text: 'Preço Médio (R$/l)', value: 'precoMedio', align: 'right', width: '16%', class: 'black--text title' },
        { text: 'Estoque', value: 'estoque', align: 'right', width: '16%', class: 'black--text title' },
        { text: 'Custo Total', value: 'custoTotal', align: 'right', width: '16%', class: 'black--text title' },
      ],
      headersProdutos: [
        { text: 'Produto', value: 'produto', width: '16%', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', width: '12%', class: 'black--text title' },
        { text: 'Ultima Venda', value: 'ultimaVenda', align: 'right', width: '12%', class: 'black--text title' },
        { text: 'Dias Não Movimentados', value: 'diasMovimentados', align: 'right', width: '12%', class: 'black--text title' },
        { text: 'Volume (l)', value: 'volume', align: 'right', width: '12%', class: 'black--text title' },
        { text: 'Preço Médio (R$/l)', value: 'precoMedio', align: 'right', width: '12%', class: 'black--text title' },
        { text: 'Estoque', value: 'estoque', align: 'right', width: '12%', class: 'black--text title' },
        { text: 'Custo Total', value: 'custoTotal', align: 'right', width: '12%', class: 'black--text title' },
      ],
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true

        this.paginaEnable = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingAnaliseProduto1 = 'padding-right: 106rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingAnaliseProduto1 = 'padding-right: 80rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingAnaliseProduto1 = 'padding-right: 18rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingAnaliseProduto1 = 'padding-right: 20rem !important'
        } else {
          this.dynamicPaddingAnaliseProduto1 = 'padding-right: 71rem !important'
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, areas, redes, supervisores, receita, segmento, classificacao, produto, cidade, categoria, promotor, linhasProducao) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.empresa = select
        this.vendedor = vendedores
        this.supervisor = supervisores
        this.area = areas
        this.redes = redes
        this.classificacao = classificacao
        this.linhasProducao = linhasProducao
        this.cidades = cidade

        this.updateDate()
      },

      async updateDate () {
        this.dadosClassificacao = []
        this.expanded = []

        this.ordenarDados = ''
        this.ordenacaoDadosDecrescente = false
        this.ordenarDadosProdutos = ''
        this.ordenacaoDadosProdutosDecrescente = false

        this.enableBtn = false

        this.enableEstoque = false
        this.selectEstoque = []

        this.loading = true

        await Produto.showAnalise5ProdutosNaoComercializados(this.primeiroDia, this.ultimoDia, this.empresa, this.vendedor, this.area, this.redes, this.supervisor, this.classificacao, this.linhasProducao, this.cidades, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.dadosClassificacao = resposta.data.dados.map((item) => {
              var listaDados = ({
                classificacao: item.classificacao,
                faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                volume: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                precoMedio: parseFloat(item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                estoque: parseFloat(item.estoque).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                estoqueFiltro: parseFloat(item.estoque),
                custoTotal: parseFloat(item.custoTotal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                faturamentoOrdenacao: parseFloat(item.faturamento),
                volumeOrdenacao: parseFloat(item.volume),
                precoMedioOrdenacao: parseFloat(item.precoMedio),
                estoqueOrdenacao: parseFloat(item.estoque),
                custoTotalOrdenacao: parseFloat(item.custoTotal),
                expandir: item.expandir,
                dadosProdutos: this.dadosProdutos(item.dadosProdutos),
              })

              return listaDados
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.dadosClassificacao = []

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.msg
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => {
          this.loading = false

          this.enableEstoque = true

          this.enableBtn = true
        })
      },

      dadosProdutos (value) {
        const dados = value.map((item) => {
          var listaDados = ({
            id: item.id_produto,
            produto: item.produto,
            dataFatura: item.data_fatura,
            diasSemFaturamento: item.diasSemFaturamento,
            faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            volume: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            precoMedio: parseFloat(item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            faturamentoOrdenacao: parseFloat(item.faturamento),
            estoque: parseFloat(item.estoque).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            estoqueFiltro: parseFloat(item.estoque),
            custoTotal: parseFloat(item.custoTotal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            dataFaturaOrdenacao: item.dataOrdenacao,
            volumeOrdenacao: parseFloat(item.volume),
            precoMedioOrdenacao: parseFloat(item.precoMedio),
            estoqueOrdenacao: parseFloat(item.estoque),
            custoTotalOrdenacao: parseFloat(item.custoTotal),
          })

          return listaDados
        })

        return dados
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },

      mudarOrdenacao (campo) {
        if (this.ordenarDados === campo) {
          this.ordenacaoDadosDecrescente = !this.ordenacaoDadosDecrescente
        } else {
          this.ordenarDados = campo
          this.ordenacaoDadosDecrescente = false
        }

        this.buscarDadosOrdenados()
      },

      buscarDadosOrdenados () {
        var novaOrdenacao = []

        if (this.dadosClassificacaoFiltro.length > 0) {
          novaOrdenacao = [...this.dadosClassificacaoFiltro]
        } else {
          novaOrdenacao = [...this.dadosClassificacao]
        }

        novaOrdenacao.sort((a, b) => {
          let result = 0

          if (a[this.ordenarDados] < b[this.ordenarDados]) result = -1
          if (a[this.ordenarDados] > b[this.ordenarDados]) result = 1

          if (this.ordenacaoDadosDecrescente) result *= -1

          return result
        })

        if (this.dadosClassificacaoFiltro.length > 0) {
          this.dadosClassificacaoFiltro = novaOrdenacao
        } else {
          this.dadosClassificacao = novaOrdenacao
        }
      },

      mudarOrdenacaoProduto (campo, index) {
        if (campo === this.ordenarDadosProdutos) {
          this.ordenacaoDadosProdutosDecrescente = !this.ordenacaoDadosProdutosDecrescente
        } else {
          this.ordenarDadosProdutos = campo
          this.ordenacaoDadosProdutosDecrescente = false
        }

        this.ordenarDadosProduto(index)
      },

      ordenarDadosProduto (index) {
        var novaOrdenacao = []

        if (this.dadosClassificacaoFiltro.length > 0) {
          novaOrdenacao = [...this.dadosClassificacaoFiltro[index].dadosProdutos]
        } else {
          novaOrdenacao = [...this.dadosClassificacao[index].dadosProdutos]
        }

        novaOrdenacao.sort((a, b) => {
          let result = 0

          if (a[this.ordenarDadosProdutos] < b[this.ordenarDadosProdutos]) result = -1
          if (a[this.ordenarDadosProdutos] > b[this.ordenarDadosProdutos]) result = 1

          if (this.ordenacaoDadosProdutosDecrescente) result *= -1

          return result
        })

        if (this.dadosClassificacaoFiltro.length > 0) {
          this.dadosClassificacaoFiltro[index].dadosProdutos = novaOrdenacao
        } else {
          this.dadosClassificacao[index].dadosProdutos = novaOrdenacao
        }
      },

      filtrarEstoque () {
        if (this.selectEstoque.id === 2) {
          this.dadosClassificacaoFiltro = this.dadosClassificacao.filter(item => item.estoqueFiltro > 0).map((item) => {
            return {
              classificacao: item.classificacao,
              faturamento: item.faturamento,
              volume: item.volume,
              precoMedio: item.precoMedio,
              estoque: item.estoque,
              estoqueFiltro: item.estoqueFiltro,
              custoTotal: item.custoTotal,
              faturamentoOrdenacao: item.faturamentoOrdenacao,
              volumeOrdenacao: item.volumeOrdenacao,
              precoMedioOrdenacao: item.precoMedioOrdenacao,
              estoqueOrdenacao: item.estoqueOrdenacao,
              custoTotalOrdenacao: item.custoTotalOrdenacao,
              expandir: item.expandir,
              dadosProdutos: this.dadosProdutosEstoque(item.dadosProdutos),
            }
          })
        } else {
          this.dadosClassificacaoFiltro = []
        }
      },

      dadosProdutosEstoque (lista) {
        const dados = lista.filter(item => item.estoqueFiltro > 0)
          .map((item) => {
            var listaDados = ({
              id: item.id,
              produto: item.produto,
              dataFatura: item.dataFatura,
              diasSemFaturamento: item.diasSemFaturamento,
              faturamento: item.faturamento,
              volume: item.volume,
              precoMedio: item.precoMedio,
              faturamentoOrdenacao: item.faturamentoOrdenacao,
              estoque: item.estoque,
              estoqueFiltro: item.estoqueFiltro,
              custoTotal: item.custoTotal,
              dataFaturaOrdenacao: item.dataFaturaOrdenacao,
              volumeOrdenacao: item.volumeOrdenacao,
              precoMedioOrdenacao: item.precoMedioOrdenacao,
              estoqueOrdenacao: item.estoqueOrdenacao,
              custoTotalOrdenacao: item.custoTotalOrdenacao,
            })

            return listaDados
          })

        return dados
      },

      async imprimirPdf () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          let posYFiltros = 10

          const title = 'Filtros selecionados'

          pdf.text(title, 105, posYFiltros)

          const dataInicial = this.primeiroDia.substr(8) + '/' + this.primeiroDia.substr(5, 2) + '/' + this.primeiroDia.substr(0, 4)

          const ultimoDia = this.ultimoDia.substr(8) + '/' + this.ultimoDia.substr(5, 2) + '/' + this.ultimoDia.substr(0, 4)

          const datas = 'Data inicial: ' + dataInicial + ' - Data final: ' + ultimoDia

          posYFiltros += 10

          pdf.setFontSize(10)

          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          // this.primeiroDia, this.ultimoDia, this.empresa, this.vendedor, this.area, this.redes, this.supervisor, this.classificacao, this.linhasProducao, this.cidades
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.empresa.map(e => e.nomeExibicao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedor.map(v => v.vendedor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.area.map(a => a.area))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Supervisor(es) Selecionado(s):', this.supervisor.map(s => s.supervisor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Classificação(ões) Selecionada(s):', this.classificacao.map(c => c.classificacao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Linha(s) Produção Selecionada(s):', this.linhasProducao.map(l => l.linhaProducao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Cidade(s) Selecionada(s):', this.cidades.map(c => c.cidade))

          if (posYFiltros > 80) {
            pdf.addPage()

            posYFiltros = 10
          }

          posYFiltros += 10

          const titleDados = 'Produtos não Comercializados'

          pdf.text(titleDados, 105, posYFiltros)

          posYFiltros += 10

          const tableAux = this.dadosClassificacaoFiltro.length > 0 ? this.dadosClassificacaoFiltro : this.dadosClassificacao

          let previousTableY = posYFiltros

          tableAux.forEach((row, index) => {
            const dadosTabelaPrincipal = [
              [row.classificacao, row.faturamento, row.volume, row.precoMedio, row.estoque, row.custoTotal],
            ]

            const tablePrincipal = pdf.autoTable({
              head: [this.headers.map(header => ({ content: header.text, styles: { fontSize: 8, textColor: [0, 0, 0] } }))],
              body: dadosTabelaPrincipal.map(r => r.map((cell, index) => {
                const isTextColumn = index === 0
                return {
                  content: cell,
                  styles: {
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    halign: isTextColumn ? 'left' : 'right',
                  },
                }
              })),
            })

            previousTableY = tablePrincipal.lastAutoTable.finalY

            const dadosDetalheProdutos = row.dadosProdutos.map(item => [item.produto, item.faturamento, item.dataFatura, item.diasSemFaturamento, item.volume, item.precoMedio, item.estoque, item.custoTotal])

            const tableDetalhes = pdf.autoTable({
              head: [this.headersProdutos.map(header => ({ content: header.text, styles: { fontSize: 8, textColor: [0, 0, 0] } }))],
              body: dadosDetalheProdutos.map(r => r.map((c, i) => {
                const isTextColumnProdutos = i === 0
                return {
                  content: c,
                  styles: {
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    halign: isTextColumnProdutos ? 'left' : 'right',
                  },
                }
              })),
              startY: previousTableY,
              styles: { fontSize: 8 },
            })

            previousTableY = tableDetalhes.lastAutoTable.finalY + 10
          })

          pdf.save('relatorio_produtos_nao_comecializados.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.imprimindo = false
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      async exportExcel () {
        try {
          this.imprimindoExcel = true

          await setTimeout(() => {
            this.printExcel()
          }, 2000)
        } catch (error) {
          console.error('Erro ao exportar excel', error)
        }
      },

      async printExcel () {
        try {
          const workbook = new ExcelJS.Workbook()
          const worksheet = workbook.addWorksheet('Relatório Produtos Não Comercializados')

          let posY = 1

          const inserirTitulo = (worksheet) => {
            worksheet.mergeCells(`A${posY}:D${posY}`)
            worksheet.getCell(`A${posY}`).value = 'Filtros selecionados'
            worksheet.getCell(`A${posY}`).font = { size: 14, bold: true }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            const dataInicial = this.primeiroDia.substr(8) + '/' + this.primeiroDia.substr(5, 2) + '/' + this.primeiroDia.substr(0, 4)
            const ultimoDia = this.ultimoDia.substr(8) + '/' + this.ultimoDia.substr(5, 2) + '/' + this.ultimoDia.substr(0, 4)
            worksheet.mergeCells(`A${posY}:D${posY}`)
            worksheet.getCell(`A${posY}`).value = `Data inicial: ${dataInicial} - Data final: ${ultimoDia}`
            worksheet.getCell(`A${posY}`).font = { size: 10 }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            const adicionarFiltros = (worksheet, posY, titulo, dados) => {
              if (dados.length > 0) {
                const texto = titulo + ' ' + dados.join(', ')

                worksheet.getCell(`A${posY}`).value = texto
                worksheet.getCell(`A${posY}`).font = { size: 10 }
                worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

                return posY + 1
              }
              return posY
            }

            posY = adicionarFiltros(worksheet, posY, 'Empresa(s) Selecionada(s):', this.empresa.map(e => e.nomeExibicao))
            posY = adicionarFiltros(worksheet, posY, 'Vendedor(es) Selecionado(s):', this.vendedor.map(v => v.vendedor))
            posY = adicionarFiltros(worksheet, posY, 'Área(s) Selecionada(s):', this.area.map(a => a.area))
            posY = adicionarFiltros(worksheet, posY, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))
            posY = adicionarFiltros(worksheet, posY, 'Supervisor(es) Selecionado(s):', this.supervisor.map(s => s.supervisor))
            posY = adicionarFiltros(worksheet, posY, 'Classificação(ões) Selecionada(s):', this.classificacao.map(c => c.classificacao))
            posY = adicionarFiltros(worksheet, posY, 'Linha(s) Produção Selecionada(s):', this.linhasProducao.map(l => l.linhaProducao))
            posY = adicionarFiltros(worksheet, posY, 'Cidade(s) Selecionada(s):', this.cidades.map(c => c.cidade))

            posY += 1

            worksheet.addRow([])
          }

          posY += 1

          const ajustarLarguraColunas = (worksheet, headers, tableData) => {
            headers.forEach((header, i) => {
              let maxColumnWidth = header.length
              tableData.forEach(row => {
                const columnText = row[i] ? row[i].toString() : ''
                maxColumnWidth = Math.max(maxColumnWidth, columnText.length)
              })
              worksheet.getColumn(i + 1).width = maxColumnWidth + 2
            })
          }

          inserirTitulo(worksheet)

          posY += 2

          const tableHeaders = this.headers.map(header => header.text)

          const tableAux = this.dadosClassificacaoFiltro.length > 0 ? this.dadosClassificacaoFiltro : this.dadosClassificacao

          tableAux.forEach(row => {
            worksheet.addRow(this.headers.map(h => h.text)).font = { bold: true }

            worksheet.addRow(
              [row.classificacao, row.faturamento, row.volume, row.precoMedio, row.estoque, row.custoTotal],
            )

            worksheet.addRow(this.headersProdutos.map(h => h.text)).font = { bold: true }

            row.dadosProdutos.forEach(prod => {
              worksheet.addRow([
                prod.produto,
                prod.faturamento,
                prod.dataFatura,
                prod.diasSemFaturamento,
                prod.volume,
                prod.precoMedio,
                prod.estoque,
                prod.custoTotal,
              ])
            })

            worksheet.addRow([])
          })
          posY += tableAux.length + 1

          ajustarLarguraColunas(worksheet, tableHeaders, tableAux)

          const buffer = await workbook.xlsx.writeBuffer()
          saveAs(new Blob([buffer]), 'relatorio_produtos_nao_comercializados.xlsx')
        } catch (error) {
          console.error('Erro ao gerar Excel:', error)
        } finally {
          this.imprimindoExcel = false
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }

</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  .highlighted-item {
    background-color: #2863af;
    padding: 16px;
    color: white;
    margin: -1rem 0 0 0;
  }

  #listItemFaturamentoGrupos {
    margin: -2rem 0 0 -1rem;
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important
  }
</style>

<style lang="sass">

</style>
